import { render, staticRenderFns } from "./LiabilitiesDetailsView.vue?vue&type=template&id=7b100f9d&"
import script from "./LiabilitiesDetailsView.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports